import { ProFormColumnsType } from '@ant-design/pro-components';
import { createCurrencyFormItem } from '../createCurrencyFormItem';
import { createNumberFormItem, createTextFormItem } from './createTextFormItem';

export const partnershipFormSchema = (): ProFormColumnsType[] => [
  {
    valueType: 'group',
    columns: [
      ...['companyName', 'occupation'].map(item => createTextFormItem(item, 'member.income')),
      ...['timeTrading'].map(item => createNumberFormItem(item, 'member.income', 1)),
      ...['netTaxableIncomeMostRecentYear', 'netTaxableIncomePriorYear'].map(item =>
        createCurrencyFormItem(null, item, 'member.income', undefined, true),
      ),
    ],
  },
];
